import { render, staticRenderFns } from "./RdDashboard.vue?vue&type=template&id=16366187&scoped=true&"
import script from "./RdDashboard.vue?vue&type=script&lang=js&"
export * from "./RdDashboard.vue?vue&type=script&lang=js&"
import style0 from "./RdDashboard.vue?vue&type=style&index=0&id=16366187&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16366187",
  null
  
)

export default component.exports